import { useState, useEffect } from "react";
import { GOOGLE_PLACES_API_KEY as apiKey } from "@/utils/const";

let warningsSuppressed = false;

function suppressGoogleMapsWarnings() {
	if (warningsSuppressed) return;
	warningsSuppressed = true;

	const originalWarn = console.warn;
	const originalLog = console.log;

	const isMapsNoise = (args: unknown[]) => {
		const msg = args.join(" ");
		return (
			msg.includes("Google Maps JavaScript API") ||
			msg.includes("google.maps.places.Autocomplete") ||
			msg.includes("loading=async") ||
			msg.includes("PlaceAutocompleteElement")
		);
	};

	console.warn = (...args) => { if (!isMapsNoise(args)) originalWarn.apply(console, args); };
	console.log = (...args) => { if (!isMapsNoise(args)) originalLog.apply(console, args); };
}

export function useGoogleMapsScript(): { isLoaded: boolean } {
	const [isLoaded, setIsLoaded] = useState(
		typeof window !== "undefined" && !!window.google?.maps?.places,
	);

	useEffect(() => {
		suppressGoogleMapsWarnings();

		if (!apiKey || apiKey === "undefined") return;
		if (window.google?.maps?.places) { setIsLoaded(true); return; }

		const existing = document.querySelector<HTMLScriptElement>(
			'script[src*="maps.googleapis.com"]',
		);

		if (existing) {
			const onLoad = () => setIsLoaded(true);
			existing.addEventListener("load", onLoad);
			return () => existing.removeEventListener("load", onLoad);
		}

		const script = document.createElement("script");
		script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&v=weekly`;
		script.async = true;
		script.defer = true;
		script.onload = () => setIsLoaded(true);
		document.head.appendChild(script);
	}, []);

	return { isLoaded };
}
